var headlinesArr = []
var anchors = document.querySelectorAll('.js-anchor .nav')
var range = 0 
var app = {
  init:function() {
    this.bindEvent()
  },
  bindEvent: function(){
    this.bindScroll()
    var that = this
    $(window).on("scroll", this.onScroll)

    for (let i = 0; i < anchors.length; i++) {
      anchors[i].addEventListener('click', () => {
        that.initHeadlines()
        that.anchorTo(i)
      })
    }

    $(".btn-gotop").on("click", function() {
      $("html, body").stop().animate({
        scrollTop: 0
      },500);
      $('[data-section]').removeClass('active')
    });

  },

  initHeadlines () {
    headlinesArr = []
    var headlines = $('[data-section]')
    headlines.each(function(){
      headlinesArr.push({
        top: $(this).offset().top - range,
      })
    })
  },
  setCurrentAnchor(index) {
    for (var i = 0; i < anchors.length; i++) {
      if (i === index) {
        $(anchors[i]).addClass('active')
      } else {
        $(anchors[i]).removeClass('active')
      }
    }
  },
  anchorTo(index) {
    var headline = headlinesArr[index]
    if (headline) {
      $("html, body").stop().animate({
        scrollTop: headline.top
      },500,"swing")
    }
  },
  bindScroll() {
    var that = this
    function calcAnchorIndex(){
      that.initHeadlines()
      var scrollTop = $(document).scrollTop()
      for (var i = 0; i < headlinesArr.length; i++) {
        if (
          headlinesArr[i].top >= scrollTop ||
          (!!headlinesArr[i + 1] && headlinesArr[i + 1].top >= scrollTop + window.innerHeight * 0.6)
        ) {
          that.setCurrentAnchor(i)
          break
        }
      }
    }
    calcAnchorIndex()
    $(window).on("scroll", calcAnchorIndex);
  },
  onScroll() {
    var sectionArr = [];
    var scrollPos = $(document).scrollTop() + $(window).height() / 2;
    $('[data-section]').each(function(){
      sectionArr.push({
        begin: $(this).offset().top + 1,
        end: $(this).offset().top + $(this).height()
      })
    })
    sectionArr.forEach(function(o, i) {
      if (scrollPos > o.begin && scrollPos < o.end) {
        $('[data-section]:eq('+i+')').addClass('active').siblings().removeClass('active');
      }
    });
  },
}
app.init()